import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  gray: {
    accent: "#404040",
    normal: "#808080",
    blur: "#d9d9d9",
    semiblur: "#b3b3b3",
    bg: "#F6F7FA",
    button: "#ADB2C1",
  },
  blue: { accent: "#0075FF", mild: "#7FBAFF", light: "#D9EAFF" },
};
